<template>
  <MtxCard class="my-submissions mt-3">
    <h4 class="text-center">My Submissions</h4>
    <template v-if="submissions.length">
      <ul class="my-submissions__list list-plain my-4">
        <li
          v-for="submission of submissions"
          :key="submission.hash"
          class="flex align-center justify-between mb-2"
        >
          <div>
            <RouterLink :to="`/submissions/${submission.hash}`" class="heading-6 mb-0">
              {{ submission.title | truncate }}
            </RouterLink>
            <div>
              <small>
                submitted to
                <RouterLink :to="`/tournaments/${submission.tournament}`">
                  {{ submission.tournament | ethAddress }}
                </RouterLink>
                on {{ (submission.timestamp * 1000) | date("MMM Do, YYYY") }} at
                {{ (submission.timestamp * 1000) | date("h:mma") }}
              </small>
            </div>
          </div>
          <div class="ml-1 text-right flex-shrink-0" :class="{ 'color-muted': !submission.reward }">
            {{ submission.reward | mtx }}
            <MtxSvg icon="icon-trophy" />
          </div>
        </li>
      </ul>

      <div class="text-center">
        <button v-if="hasMore" :disabled="isLoading" @click="getSubmissions">load more</button>
        <button v-else disabled>no more</button>
      </div>
    </template>

    <div v-else class="text-center">
      <p>You have not created any submissions yet.</p>
      <RouterLink to="/tournaments" class="btn">Go to Tournaments</RouterLink>
    </div>
  </MtxCard>
</template>

<script>
import web3 from "@/mixins/web3"
import API from "@/api"

export default {
  mixins: [web3],

  data: () => ({
    hasMore: false,
    isLoading: false,
    submissions: []
  }),

  watch: {
    "$store.state.user.ethAddress": {
      async handler() {
        this.submissions = []
        await this.getSubmissions()
      },
      immediate: true
    }
  },

  methods: {
    async getSubmissions() {
      this.isLoading = true

      const { data, success } = await API.getSubmissionsByOwner({
        owner: this.$store.state.user.ethAddress,
        offset: this.submissions.length
      })

      if (success) {
        this.submissions.push(...data.submissions)
        this.hasMore = !!data.submissions.length
      }

      this.isLoading = false
    }
  }
}
</script>
